import type { ReactNode } from 'react';
import { card, sectionTitle, textBody, textMeta } from '../../uiStyles';

type GradeFlowShellProps = {
  step: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  /** When false, the body does not scroll as one block — use for nested column scroll (e.g. audit studio). Default true. */
  bodyScrollable?: boolean;
};

export function GradeFlowShell({
  step,
  title,
  subtitle,
  children,
  footer,
  className = '',
  bodyScrollable = false,
}: GradeFlowShellProps): ReactNode {
  return (
    <div
      className={`flex min-h-0 flex-1 flex-col gap-3 overflow-hidden pb-3 pt-1 ${className}`.trim()}
    >
      <section className={card}>
        <p className={sectionTitle}>{step}</p>
        <h2 className={`mt-1 text-sm font-black text-slate-900 dark:text-slate-100 ${textBody}`}>
          {title}
        </h2>
        {subtitle ? <p className={`mt-1 ${textMeta}`}>{subtitle}</p> : null}
      </section>

      <div
        className={
          bodyScrollable
            ? 'flex min-h-0 flex-1 flex-col overflow-hidden'
            : 'flex min-h-0 flex-1 flex-col overflow-hidden'
        }
      >
        {children}
      </div>

      {footer ? <div className="shrink-0">{footer}</div> : null}
    </div>
  );
}
